function checkOfferFilters() {
    const btn = document.querySelector('#sk-CompareHomeUIDefinition [id*="filters-action-button"]');

    if ( btn ) {
        filters = document.querySelectorAll('[data-attr-id*="Compare.filters.filter"]');
        btn.addEventListener("click", () => {
            for ( [i,filter] of [...filters].entries() ) {
                input = filter.querySelector("input");
                if ( input.checked ) {
                    filter.querySelector("input").click();
                }
            }
        });
    }
};

export { checkOfferFilters };